import { render } from "./privacyModal.vue?vue&type=template&id=dd299d10"
import script from "./privacyModal.vue?vue&type=script&lang=js"
export * from "./privacyModal.vue?vue&type=script&lang=js"

import exportComponent from "/usr/share/nginx/elsaygh_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__